import PaymentButton from "../../components/PaymentButton";
import PhoneIcon from "../../assets/images/payment/solar_phone-bold.png";
import VideoIcon from "../../assets/images/payment/lsicon_file-movie-outline.png";
import CustomerCenterButton from "../../components/CustomerCenterButton";
import { useNavigate } from "react-router-dom";
import { PREMIUM_MANSEOL_PRICE } from "../../utils/constants";

function PaymentMainPage() {
  const navigate = useNavigate();

  return (
    <main className="flex flex-col items-center px-4 pt-10 pb-10 font-[NanumMyeongjo]">
      <div className="text-center mb-6">
        <p className="text-2xl font-medium mb-5">
          사주의 특징과 궁금한 점<br />
          <strong>모두 알려드리는 "프리미엄 사주"</strong>
        </p>
        <p className="text-2xl mt-2 mb-9">
          전화/영상 택 1{" "}
          <strong className="text-4xl font-extrabold ml-2">
            {PREMIUM_MANSEOL_PRICE.toLocaleString()}원
          </strong>
        </p>
      </div>
      <div className="w-full flex flex-col gap-4 max-w-[320px] mx-auto">
        <PaymentButton
          icon={<img src={VideoIcon} alt="video" className="w-10 h-10" />}
          className="bg-[#EEE6FF] border-[#9D7FDE] border"
          subText="(24시간 이내 메일로 전송)"
          onClick={() => {
            navigate("/payment/info/video");
          }}
        >
          <p className="text-sm mb-1">10분 분량의</p>
          <p className="text-2xl">
            사주풀이 <strong>영상</strong>받기
          </p>
        </PaymentButton>
        <PaymentButton
          icon={<img src={PhoneIcon} alt="phone" className="w-10 h-10" />}
          className="bg-white border-black border"
          subText="(카카오톡 채널로 상담시간 예약하기)"
          onClick={() => {
            navigate("/payment/info/phone");
          }}
        >
          <p className="text-sm mb-1">20분 이내</p>
          <p className="text-2xl">
            <strong>전화</strong>로 상담받기
          </p>
        </PaymentButton>
      </div>
      <div className="flex flex-col items-center mt-10">
        <CustomerCenterButton />
        <div className="text-sm text-[#5E5E5E] mt-2">
          전화 상담 일정 및 환불 문의
        </div>
      </div>
    </main>
  );
}

export default PaymentMainPage;
